import { db } from "./firebaseServices.js";

function checkNickname(testedNickname) {
  return db
    .collection("users")
    .where("userData.nickname", "==", testedNickname)
    .get()
    .then((querySnapshot) => {
      if (querySnapshot.empty) {
        return true;
      } else {
        return false;
      }
    });
}

export { checkNickname };

// Change profile & Sign up
